import { useEffect, useState } from "react";
import { doc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";

const TEXT_LIMIT = 5000;

function RegulaminAdm({ userEmail, onLogout, userRole }) {
	const [formValues, setFormValues] = useState({
		section1: "",
		section2: "",
		section3: "",
		section4: "",
		section5: ""
	});
	const [status, setStatus] = useState({ type: "", message: "" });
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		const docRef = doc(db, "regulamin", "content");
		const unsubscribe = onSnapshot(
			docRef,
			(snapshot) => {
				if (!snapshot.exists()) {
					return;
				}
				const data = snapshot.data();
				setFormValues({
					section1: data.section1 || "",
					section2: data.section2 || "",
					section3: data.section3 || "",
					section4: data.section4 || "",
					section5: data.section5 || ""
				});
			},
			(error) => {
				setStatus({
					type: "error",
					message: error.message || "Nie udalo sie wczytac regulaminu."
				});
			}
		);

		return () => unsubscribe();
	}, []);

	const handleChange = (key) => (event) => {
		const value = event.target.value;
		setFormValues((prev) => ({
			...prev,
			[key]: value
		}));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setStatus({ type: "", message: "" });

		const tooLong = Object.entries(formValues).find(
			([, value]) => value.length > TEXT_LIMIT
		);
		if (tooLong) {
			setStatus({
				type: "error",
				message: "Maksymalna dlugosc tekstu to 5000 znakow."
			});
			return;
		}

		setSaving(true);
		try {
			await setDoc(
				doc(db, "regulamin", "content"),
				{
					section1: formValues.section1,
					section2: formValues.section2,
					section3: formValues.section3,
					section4: formValues.section4,
					section5: formValues.section5,
					updatedAt: serverTimestamp()
				},
				{ merge: true }
			);
			setStatus({ type: "success", message: "Zapisano regulamin." });
		} catch (error) {
			setStatus({
				type: "error",
				message: error.message || "Nie udalo sie zapisac regulaminu."
			});
		} finally {
			setSaving(false);
		}
	};

	return (
		<div className="HomeShell">
			<Navbar menuItems={menuItems} onLogout={onLogout} userRole={userRole} />

			<div className="WelcomePanel">
				<p className="Badge">Regulamin</p>
				<h1 className="Title">Teksty regulaminu</h1>
				<p className="Subtitle">Zalogowano jako {userEmail}.</p>

				<form className="Form" onSubmit={handleSubmit}>
					<label className="Field">
						<span className="Label">Sekcja 1</span>
						<textarea
							className="Input TextArea"
							rows="6"
							value={formValues.section1}
							onChange={handleChange("section1")}
							maxLength={TEXT_LIMIT}
						/>
						<span className="Muted">
							{formValues.section1.length}/{TEXT_LIMIT}
						</span>
					</label>

					<label className="Field">
						<span className="Label">Sekcja 2</span>
						<textarea
							className="Input TextArea"
							rows="6"
							value={formValues.section2}
							onChange={handleChange("section2")}
							maxLength={TEXT_LIMIT}
						/>
						<span className="Muted">
							{formValues.section2.length}/{TEXT_LIMIT}
						</span>
					</label>

					<label className="Field">
						<span className="Label">Sekcja 3</span>
						<textarea
							className="Input TextArea"
							rows="6"
							value={formValues.section3}
							onChange={handleChange("section3")}
							maxLength={TEXT_LIMIT}
						/>
						<span className="Muted">
							{formValues.section3.length}/{TEXT_LIMIT}
						</span>
					</label>

					<label className="Field">
						<span className="Label">Sekcja 4</span>
						<textarea
							className="Input TextArea"
							rows="6"
							value={formValues.section4}
							onChange={handleChange("section4")}
							maxLength={TEXT_LIMIT}
						/>
						<span className="Muted">
							{formValues.section4.length}/{TEXT_LIMIT}
						</span>
					</label>

					<label className="Field">
						<span className="Label">Sekcja 5</span>
						<textarea
							className="Input TextArea"
							rows="6"
							value={formValues.section5}
							onChange={handleChange("section5")}
							maxLength={TEXT_LIMIT}
						/>
						<span className="Muted">
							{formValues.section5.length}/{TEXT_LIMIT}
						</span>
					</label>

					{status.message ? (
						<p className={status.type === "error" ? "Error" : "Success"}>
							{status.message}
						</p>
					) : null}

					<button className="Button" type="submit" disabled={saving}>
						{saving ? "Zapisywanie..." : "Zapisz regulamin"}
					</button>
				</form>
			</div>
		</div>
	);
}

export default RegulaminAdm;
